module.exports = __webpack_public_path__ + "img/share_twitter.78858c15.svg";